import React, { useState,useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from "./Compenet/Header/Header";
import Home from "./Pages/Home/Home";
import { ThemeProvider } from "./context/ThemeContext";
import About from "./Pages/About/About";
import Projects from "./Pages/Projects/Projects";
import Contact from "./Pages/Contact/Contact";
import ProjectSidebar from "./Compenet/ProjectSidebar";
import DashboardLayout from "./Compenet/Dashboard/DashboardLayout";
import Dashboard from "./Pages/Admin/Dashboard";
import axiosInstance from "./axiosInstance";

function App() {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axiosInstance.get('/projects');
      setProjects(response.data);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setIsSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-stone-100 dark:bg-[#111318]">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route
              path="/projects"
              element={
                <>
                  <Projects projects={projects} onProjectClick={handleProjectClick} />
                  <ProjectSidebar
                    project={selectedProject}
                    onClose={handleSidebarClose}
                    isOpen={isSidebarOpen}
                  />
                </>
              }
            />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/admin/aha999/*"
              element={
                <DashboardLayout>
                  <Dashboard />
                </DashboardLayout>
              }
            />
            <Route path="*" element={<h1 className="max-w-7xl mx-auto dark:text-stone-100 text-[#111318]">Not Found</h1>} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;